import React from "react";
import PropTypes from "prop-types";

// One labelled fact inside the company's Overview card: icon, label, value. Mirrors Product's own
// DetailTile (products/show/detail_tile.jsx) tile-for-tile — a second occurrence rather than a shared
// import, per the codebase's WET-before-DRY convention, since the two engines' Overview cards live in
// different subtrees. Two per row from small up, stacked below.
function CompanyDetailTile({ icon, label, children }) {
  return (
    <div className="col-12 col-sm-6 mb-3">
      <div className="d-flex">
        <i className={`${icon} text-muted mt-1 me-2`} />
        <div className="flex-grow-1 overflow-hidden">
          <div className="text-muted small">{label}</div>
          <div className="fw-semibold text-break">{children}</div>
        </div>
      </div>
    </div>
  );
}

CompanyDetailTile.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CompanyDetailTile;
